import React from 'react';
import Header from './Header';
import Navbar from './Navbar';
import Footers from './Footers';
import NewsletterSection from './NewsletterSection';
import './Faq.css';
import leafRight from '../components/assets/images/faq-1.png';
export default function Faq() {
  return (
    <div className="faq-wrapper">
      <img src={leafRight} alt="Leaf Decoration" className="leaf-right" />
      <Header />
      <Navbar />
      <div className="faq-container">
        <div className="Faq">
          <h1>Frequently Asked Questions</h1>
        </div>
        <div className="faq-section">
          <h1 className="ordering-faq">A. ORDERING</h1>

          <div className="faq-item-faq">
            <h2>Q:1 Can I buy multiple products in a single order?</h2>
            <p>Yes. Just add all the products you wish to buy into your shopping bag and then complete your order. This way you can save on any additional shipping and COD charges!</p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:2 I cannot complete my registration, what do I need to do?</h2>
            <p>Contact us, detailing the problem you have encountered. You can either email us on contact@upakarma.com or call us on 011-40691456 and our Customer Care will be happy to assist you.</p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:3 How do I know that my order is confirmed?</h2>
            <p>For all Pre-paid orders, once you place your order, your confirmation status will be automatically updated on your Account section. If your chosen mode of payment is COD, you'll get an SMS/email to confirm your order.</p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:4 How do I place my order?</h2>
            <p>
              Step 1: Click on the Category of your choice.<br />
              Step 2: Click on ADD TO CART.<br />
              Step 3: Click on BUY NOW.<br />
              Step 4: Click on CHECKOUT and complete your details.<br />
              For help, call our helpdesk at 011-40691456 or use the live chat.
            </p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:5 Can I leave items in my cart for future purchase?</h2>
            <p>Yes, you can leave items in your cart for future purchase, but product availability and prices may change, and items could go out of stock or discounts may expire.</p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:6 What are the benefits of signing in?</h2>
            <p>
              Signing in allows you to:<br />
              1. Track past purchases.<br />
              2. Earn Upakarma points through purchases and referrals.
            </p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:7 I cannot complete my registration, what do I need to do?</h2>
            <p>If you're unable to complete your registration, please contact our Customer Care team by emailing contact@------.com or calling -----------. We're happy to assist you with the issue.</p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:8 What payment types do you offer?</h2>
            <p>We offer multiple payment options. For Indian orders: Cash on Delivery, Debit/Credit Card, and Net Banking. For international orders: payments can be made using PayPal and Credit Card only.</p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:9 What is Cash on Delivery (COD)?</h2>
            <p>Cash on Delivery (COD) allows you to pay for your order in cash when it is delivered to your doorstep. This option is available only in Indian Rupees and selected pin codes.</p>
          </div>
        </div>

        {/* Section B */}
        <div className="faq-section">
          <h1 className="ordering-faq">B. SHIPPING AND DELIVERY POLICIES</h1>

          <div className="faq-item-faq">
            <h2>Q:1 How does the delivery process work?</h2>
            <p>All orders are shipped through trusted courier partners. Once dispatched, you’ll receive an email with the tracking number and courier details to monitor your order’s delivery status online.</p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:2 What is the range of locations to which we ship our products?</h2>
            <p>We ship across India. Orders above ₹290 qualify for free shipping. For orders below ₹290, a flat shipping charge of ₹70 is applicable.</p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:3 How Can I track my order?</h2>
            <p>You can track your order through the “Track Your Order” section in your account. You’ll also receive a tracking number via email once your order is shipped.</p>
          </div>
        </div>

        {/* Section C */}
        <div className="faq-section">
          <h1 className="ordering-faq">C. RETURNS, CANCELLATIONS & EXCHANGES</h1>

          <div className="faq-item-faq">
            <h2>Q:1 What is your Online Return Policy?</h2>
            <p>It seems like you're asking about an online return policy, but I need some clarification on which specific business or company you're referring to. If you want help crafting a return policy for your business, I can assist with that. Typically, an online return policy includes information about.</p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:2 How do I cancel my order?</h2>
            <p>To cancel your order, contact us within 1-2 hours via email or phone with your order number. If shipped, returns can be processed once the item is delivered.</p>
          </div>

          <div className="faq-item-faq">
            <h2>Q:3 How will I get a refund for my cancelled orders and how long will this process take?</h2>
            <p>Refunds for canceled orders will be processed to your original payment method. The process typically takes 5-7 business days, depending on your payment provider’s policies.</p>
          </div>
        </div>
      </div>
      <NewsletterSection />
      <Footers />
    </div>
  );
}
